import { render, staticRenderFns } from "./Shippermanagement.vue?vue&type=template&id=2ce21536&scoped=true&"
import script from "./Shippermanagement.vue?vue&type=script&lang=js&"
export * from "./Shippermanagement.vue?vue&type=script&lang=js&"
import style0 from "./Shippermanagement.vue?vue&type=style&index=0&id=2ce21536&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce21536",
  null
  
)

export default component.exports